// Step 18 — small shell primitives reused across every AI page.
//
// Reuses existing `.qai-*` conventions from ai.css so the loading /
// empty / error states look consistent with the surrounding
// components (DealSituationPanel, ContractsPanel, etc.).

export function AILoading({ label = "Laddar…" }) {
  return <div className="qai-shell-loading">{label}</div>;
}

export function AIEmpty({ title, hint, children }) {
  return (
    <div className="qai-shell-empty">
      {title && <div className="qai-shell-empty-title">{title}</div>}
      {hint && <div className="qai-shell-empty-hint">{hint}</div>}
      {children}
    </div>
  );
}

export function AIError({ message }) {
  if (!message) return null;
  return <div className="qai-shell-error">{message}</div>;
}

export function AIPageHeader({ title, subtitle, actions }) {
  return (
    <header className="qai-page-header">
      <div className="qai-page-header-titles">
        <h1 className="qai-page-title">{title}</h1>
        {subtitle && <div className="qai-page-subtitle">{subtitle}</div>}
      </div>
      {actions && <div className="qai-page-header-actions">{actions}</div>}
    </header>
  );
}

export function AISection({ title, right, children }) {
  return (
    <section className="qai-page-section">
      {(title || right) && (
        <div className="qai-page-section-head">
          {title && <h2 className="qai-page-section-title">{title}</h2>}
          {right}
        </div>
      )}
      {children}
    </section>
  );
}
